import { MetaAtributoAdicionalDTO } from '../_dtos/MetaAtributoAdicionalDTO';
import { BaseBean } from './BaseBean';
import { ConfiguracionPlanBean } from './ConfiguracionPlanBean';
import { ObjetivoBean } from './ObjetivoBean';
import { ResponsableMetaBean } from './ResponsableMetaBean';

export class MetaBean extends BaseBean {

  public id: number;
  public descripcion: string;
  public codigo: string;
  public fechaInicio: Date;
  public fechaFin: Date;
  public idFrecControl: string;
  public avance: number;
  public objetivo: ObjetivoBean;
  public detalleMeta : any;
  public valorEsperadoMetaList:any;
  public lineaBase: number;
  public formaMedicion: number;
  public variableMetaList:any[];
  public idProcedimiento: number;
  public idNormativa:number
  public responsableMetaList: ResponsableMetaBean[];
  public responsableMetaDeleteList: ResponsableMetaBean[];
  public enlace: string;
  public sistema: string;
  public fuente: string;
  public contieneLengua:Boolean ;
  public publicado: string;
  //atributo transient
  public idPlan:number;
  public responsableString:string;
  public frecControlDescripcion:string;
  public nombreDinamico :string;
  public abrirDesdeMenu?:boolean;
  public configuracionPlan?:ConfiguracionPlanBean;
  public esIndicadorPorObjetivo:boolean=false;
  public valorMaximo: number;
  public valorMinimo: number;
  public valorPromedio: number;
  public esAcumulativo: Boolean

}
